





import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class PageNotFound extends Vue {
  smsSecond = 3;
  mounted(): void {
    // setTimeout((): void => {
    //   this.$router.push("/");
    // }, 3000);
    var smsTimer = setInterval(() => {
      this.smsSecond = this.smsSecond - 1;
      if (this.smsSecond <= 0) {
        clearInterval(smsTimer);
        this.$router.push("/");

        // this.smsSecond = 3;
      }
    }, 1000);
  }
}
